import React, {useEffect, useState, useRef} from 'react';
import {Dialog} from "primereact/dialog";
import connect from "react-redux/es/connect/connect";
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {InputSwitch} from 'primereact/inputswitch';
import {Link, Redirect} from 'react-router-dom';
import {Button} from "primereact/button";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import '../../css/log_table.css'
import {Dropdown} from 'primereact/dropdown';
import {ProgressSpinner} from "primereact/progressspinner";
import {Calendar} from 'primereact/calendar';
import '../../css/style.css'


const LogManagement = props => {

    const [logs, setLogs] = useState([]);
    const [textDetailPopupVisible, setTextDetailPopupVisible] = useState(false);
    const [logLoading, setLogLoading] = useState(false);
    const [logName, setLogName] = useState(null);
    const [textDetailText, setTextDetailText] = useState(null);
    const [textDetailHeader, setTextDetailHeader] = useState(null);
    const [totalLog, setTotalLog] = useState(null);
    const [loadingState, setLoadingState] = useState('none');
    const [nextPageUrl, setNextPageUrl] = useState('none');
    const [previousPageUrl, setPreviousPageUrl] = useState('none');
    const tableFontSize = '12px';
    const logListRole = !!localStorage.getItem('log_list');
    const [logUrl, setLogUrl] = useState('/api/log/list/');
    const [logListUrl, setLogListUrl] = useState('/api/log/list/');
    const dt = useRef(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 15,
        page: 1,
    });

    useEffect(() => {
        if (logListRole) {
            getLogs(logUrl);
        }
    }, []);

    const textDetail = (fulltext, text_header) => {
        setTextDetailPopupVisible(true);
        setTextDetailText(fulltext);
        setTextDetailHeader(text_header);
    }

    const textSummary = (str, header) => {
        if (str.length > 50) {
            return <div>
                {str.substring(0, 100)}...
                <Link onClick={() => textDetail(str, header)} to="#"> Devamını Gör </Link>
            </div>
        } else {
            return str
        }
    }

    const logDescription = rowData => {
        return <div>
            {textSummary(rowData['log_description'], rowData['log_id'])}
        </div>
    }

    const logStatusTemplate = (rowData) => {
        return (
            <div>
                <InputSwitch
                    checked={!rowData['log_flag_delete']}
                    onChange={() => setLogStatus(rowData)}
                />
            </div>
        )
    }

    const setLogStatus = rowData => {
        let flag = rowData['log_flag_delete'];
        let id = rowData['log_id'];
        rowData['log_flag_delete'] = !flag;
        let status_data = {
            log_flag_delete: !flag
        };
        props.updateLogStatus(id, status_data);
    }

    const getLogs = (logUrl) => {
        setLogLoading(true);
        setLogs([]);
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;

            // //console.log("*** header: ***",headers);
            fetch(logUrl, {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            setLogLoading(false);
                            return {status: res.status, data};

                        })
                    } else {
                        //console.log("Server Error!");
                        setLogLoading(false);
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        let data = res.data;
                        setLogLoading(false);
                        setTotalLog(data.count);
                        setNextPageUrl(data.next)
                        setPreviousPageUrl(data.previous);
                        setLogs(data.results);

                    } else if (res.status === 401) {
                        setLogLoading(false);
                        props.loadUser();
                        throw res.data;

                    } else if (res.status === 403) {
                        setLogLoading(false);
                        throw res.data;

                    }
                })
        }
    }

    const rowClassName = (rowData) => {
        let name = rowData.ltyp.ltyp_name;
        if (name === 'info') {
            //p-highlight
            return {'tbinfo': true};

        } else if (name === 'warning') {
            return {'tbwarning': true};

        } else if (name === 'error') {

            return {'tberror': true};
        } else if (name === 'critical') {

            return {'tbcritical': true};

        }
        return {'': (name === 'info')};
    }

    const onLogChange = (event) => {
        dt.current.filter(event.value, 'ltyp.ltyp_name', 'equals');
        setLogName(event.value);
    }

    const logUserDetail = (rowData) => {
        return (
            <div>
                <div title={rowData.user.user_username}
                     style={{overflow: 'hidden', width: '100%'}}>{rowData.user.user_username} </div>
            </div>
        )
    }

    const removeParam = (key, sourceURL) => {
        let rtn = sourceURL.split("?")[0],
            param,
            params_arr = [],
            queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
        if (queryString !== "") {
            params_arr = queryString.split("&");
            for (let i = params_arr.length - 1; i >= 0; i -= 1) {
                param = params_arr[i].split("=")[0];
                if (param === key) {
                    params_arr.splice(i, 1);
                }
            }
            if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
        }
        return rtn;
    }

    const onPage = (event) => {
        const page = event.page + 1;
        let _lazyParams = {...lazyParams, ...event};
        setLazyParams(_lazyParams);
        if (page === 0) {
            getLogs(removeParam('page', logUrl));
        } else {
            let url = null;
            if (logUrl.includes('?')) {
                if (logUrl.includes('?page')) {
                    url = removeParam('page', logUrl) + '?page=' + page;
                } else if (logUrl.includes('page')) {
                    url = removeParam('page', logUrl) + '&page=' + page;
                } else {
                    url = logUrl + '&page=' + page;
                }
                setLogUrl(url)
            } else {

                url = logUrl + '?page=' + page;
                setLogUrl(url)
            }
            getLogs(url);
        }
    }


    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({selectionOnly});
    }

    const filterDate = (value, filter) => {
        if (filter === undefined || filter === null || (typeof filter === 'string' && filter.trim() === '')) {
            return true;
        }

        if (value === undefined || value === null) {
            return false;
        }

        return value === formatDate(filter);
    }

    const formatDate = (date) => {
        let month = date.getMonth() + 1;
        let day = date.getDate();

        if (month < 10) {
            month = '0' + month;
        }

        if (day < 10) {
            day = '0' + day;
        }

        return date.getFullYear() + '-' + month + '-' + day;
    }

    const onDateChange = (e) => {
        const dateVal = e.value;
        let date = new Date(e.value)
        // Add 1 Day
        date.setDate(date.getDate() + 1);
        date = date.toISOString()
        dt.current.filter(date, 'log_createtime', 'custom');
        setSelectedDate(e.value);
    }

    const onFilter = (event) => {
        const data = Object.keys(event.filters);
        if (data.length) {
            let filterParam = '';
            let index = 0;
            data.forEach(function (key) {
                const query = event.filters[key].value;
                if (index === 0) {
                    filterParam = key.replaceAll('.', '_') + '=' + query;
                } else {
                    filterParam = filterParam + '&' + key.replaceAll('.', '_') + '=' + query;

                }
                index++;
            });
            const url = logListUrl + '?' + filterParam;
            setLogUrl(url);
            getLogs(url);
        } else {
            getLogs(logListUrl);
        }
        let _lazyParams = {...lazyParams, ...event};
        _lazyParams['first'] = 0;
        setLazyParams(_lazyParams);
    }

    if (logListRole) {
        const footer = "Toplamda " + totalLog + ' sistem işlemi kayıtlıdır';

        let header = (
            <div className="p-grid p-justify-between">
                <div className="p-col-12 p-sm-4 p-md-4">
                </div>
                <div className="p-col-12 p-sm-2 p-md-2">
                    Sistem Kayıtları
                </div>
                <div className="p-col-12 p-sm-6 p-md-6">
                    <div className="p-grid p-justify-end" style={{marginTop: '1px'}}>
                        <Button
                            type="button"
                            icon="pi pi-file-o"
                            onClick={() => exportCSV(false)}
                            className="p-mr-2"
                            data-pr-tooltip="CSV"/>
                    </div>
                </div>
            </div>
        );
        let log_types = [
            {label: 'Seçiniz', value: null},
            {label: 'info', value: 'info'},
            {label: 'warning', value: 'warning'},
            {label: 'error', value: 'error'},
            {label: 'critical', value: 'critical'},
        ];

        const logFilter = <Dropdown
            style={{
                maxWidth: '9px',
                minWidth: '7.2em'
            }}
            autoWidth={true}
            value={logName} options={log_types} onChange={(e) => onLogChange(e)}/>
        const dateFilter = <Calendar value={selectedDate} onChange={onDateChange} dateFormat="dd-mm-yy" locale="tr"
                                     className="p-column-filter" placeholder=""/>;


        return (
            <div>
                <div className="content-section implementation">
                    <DataTable
                        value={logs}
                        header={header}
                        footer={footer}
                        filterBy="log_id"
                        rowClassName={rowClassName}
                        emptyMessage="Kayıt bulunamadı"
                        exportFilename="logs"
                        ref={dt}
                        rowClassNameGetter={'row'}
                        className={'row'}
                        lazy={true}
                        rows={20}
                        first={lazyParams.first}
                        onFilter={onFilter}
                        filters={lazyParams.filters}
                        paginator={true}
                        totalRecords={totalLog}
                        onPage={onPage}
                        loading={logLoading}
                        responsive>
                        <Column
                            header="Aktiflik durumu"
                            body={logStatusTemplate}
                            style={{textAlign: 'center', width: '6em', fontSize: tableFontSize}}
                        />
                        <Column
                            field="log_id"
                            header="No"
                            sortable
                            filter
                            style={{textAlign: 'center', fontSize: tableFontSize, width: '8em'}}
                        />
                        <Column
                            field="ltyp.ltyp_name"
                            header="Tür"
                            filterElement={logFilter}
                            sortable={true}
                            filter
                            style={{textAlign: 'center', fontSize: tableFontSize, width: '13%'}}
                        />
                        <Column
                            header="Kullanıcı"
                            field="user__user_username"
                            sortable={true}
                            filter
                            body={logUserDetail}
                            style={{textAlign: 'center', fontSize: tableFontSize, width: '8%'}}
                        />
                        <Column
                            header="Modül"
                            field="md.md_name"
                            sortable={true}
                            filter
                            style={{textAlign: 'center', fontSize: tableFontSize, width: '8%'}}
                        />
                        <Column
                            body={logDescription}
                            field="log_description"
                            style={{fontSize: tableFontSize}}
                            header="Açıklama"
                            filterMatchMode="contains"
                            sortable={true}
                            filter
                        />
                        <Column
                            field="log_actionpath"
                            style={{fontSize: tableFontSize, width: '14%', overflowWrap: "break-word"}}
                            filterMatchMode="contains"
                            header="Url"
                            sortable={true}
                            filter
                        />
                        <Column
                            field="log_createtime"
                            header="Oluşma Zamanı"
                            filterElement={dateFilter}
                            filterFunction={filterDate}
                            style={{fontSize: tableFontSize, width: '18%', overflowWrap: "break-word"}}
                            sortable={true}
                            filter={true}
                        />
                    </DataTable>
                </div>
                <div className="content-section implementation">
                    <Dialog header={textDetailHeader}
                            visible={textDetailPopupVisible}
                            style={{width: '50vw'}}
                            modal={true}
                            onHide={(e) => setTextDetailPopupVisible(false)}>
                        <p>{textDetailText}</p>
                    </Dialog>
                </div>
                <div style={{
                    display: loadingState,
                    position: 'fixed',
                    padding: 0,
                    zIndex: '2',
                    width: '100%',
                    height: '100%',
                    overflow: 'visible',
                    margin: 'auto',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0
                }}>
                    <center>
                        <ProgressSpinner
                            style={{marginTop: '250px', zIndex: '4'}}
                            strokeWidth="8"
                            fill="#EEEEEE"
                            animationDuration=".5s">
                        </ProgressSpinner>
                    </center>
                </div>

            </div>
        )
    } else {
        return (
            <Redirect to="/notfound"/>
        )
    }
    //}

}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateLogStatus: (log_id, content_data) => {
            return dispatch(management.updateLogStatus(log_id, content_data));
        },
        loadUser: () => {
            return dispatch(auth.loadUser());
        },
        logout: () => dispatch(auth.logout()),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(LogManagement);


// WEBPACK FOOTER //
// ./src/pages/logmanagement/LogManagement.jsx